export default __webpack_public_path__ + "static/media/bih.98b43797.svg";